import { render, staticRenderFns } from "./DealerGroup.vue?vue&type=template&id=09a83f96&v-slot%3Aactivator=%7B%20on%2C%20attrs%20%7D&"
import script from "./DealerGroup.vue?vue&type=script&lang=js&"
export * from "./DealerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
